<script>
  import BackButton from '../general/BackButton'

  export default {
    components: {BackButton},
    name: 'list-header',
    props: ['title', 'storeRouteName', 'editRouteName', 'backRoute', 'item'],
    computed: {
      domain: function () {
        if (this.storeRouteName) {
          return this.storeRouteName.split('.')[0]
        }
        if (this.editRouteName) {
          return this.editRouteName.split('.')[0]
        }
        return ''
      },
      canStore: function () {
        return this.$can(this.domain + '.store')
      },
      canUpdate: function () {
        return this.$can(this.domain + '.update')
      }
    }
  }
</script>

<template>
    <div class="app-header">
        <h2>{{title}}</h2>
        <div>
            <slot></slot>
            <router-link :to="{ name: storeRouteName }"
                         v-if="storeRouteName && canStore"
                         class="el-button el-button--success">
                <i class="fa fa-plus"></i>
                <span>Criar {{title}}</span>
            </router-link>
            <router-link :to="{ name: editRouteName, params: { id: item.id } }"
                         v-if="editRouteName && item && canUpdate"
                         class="el-button el-button--info">
                <i class="el-icon-edit"></i>
                <span>Editar</span>
            </router-link>
            <back-button v-if="backRoute"/>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// Header.vue?679fd679